const listItemHoverEffect = (): void => {
  const listItem = document.querySelectorAll<HTMLElement>('.list-item');

  listItem.forEach((element) => {
    element.onmouseover = (): void => {
      const group: string = element.getAttribute('data-list-item-group'),
        siblings = document.querySelectorAll(
          '[data-list-item-group = ' + group + ']'
        );

      siblings.forEach((sibling) => {
        sibling.classList.remove('list-item--active');
      });
      element.classList.add('list-item--active');
    };
  });
};

export default listItemHoverEffect;
